import type { Snapshot } from "./types";

// Same-origin `/api` in production (Worker routed under the custom domain).
// Override with VITE_API_BASE for split hosting; `?demo` loads a local file.
const API_BASE = import.meta.env.VITE_API_BASE ?? "";

export async function fetchSnapshot(): Promise<Snapshot> {
  const demo = new URLSearchParams(location.search).has("demo");
  const url = demo ? "/snapshot.json" : `${API_BASE}/api/snapshot`;
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error(`snapshot fetch failed: ${res.status}`);
  return res.json();
}

// Poll fast — reads are cheap (cached KV `latest`); the adaptive pusher sets the
// real freshness floor. This keeps the live feed / activity near-real-time.
export const REFRESH_MS = 15_000;

/** POST a message to Hermes. Reply arrives via the normal snapshot polling. */
export async function sendHermesMessage(
  text: string,
  passphrase: string,
): Promise<{ ok: boolean; status: number; error?: string }> {
  try {
    const res = await fetch(`${API_BASE}/api/hermes/message`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ text, passphrase }),
    });
    if (res.ok) return { ok: true, status: res.status };
    let error: string | undefined;
    try {
      const data = await res.json();
      error = data?.error;
    } catch {
      /* non-JSON error body */
    }
    return { ok: false, status: res.status, error };
  } catch (e) {
    return { ok: false, status: 0, error: e instanceof Error ? e.message : String(e) };
  }
}
